import api from '../config/api';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.superchargeme.com';

/**
 * Credit Notes Service — API client for QuickBooks credit memos issued to
 * customers/retailers. Company + realm (connector_id) scoped server-side.
 */

export const getCreditNotes = async (params = {}) => {
  const response = await api.get(`${API_BASE}/api/quickbooks/credit-notes`, { params });
  return response.data;
};

export const getCreditNotesSummary = async (params = {}) => {
  const response = await api.get(`${API_BASE}/api/quickbooks/credit-notes/summary`, { params });
  return response.data;
};

export const getCreditNoteDetail = async (id, params = {}) => {
  const response = await api.get(`${API_BASE}/api/quickbooks/credit-notes/${id}`, { params });
  return response.data;
};

/**
 * Download the filtered credit notes as CSV. Uses the authenticated axios
 * instance (JWT lives in a header, so a plain <a href> would not carry auth) —
 * fetch as a blob and trigger a client-side download.
 */
export const downloadCreditNotesCsv = async (params = {}) => {
  const response = await api.get(`${API_BASE}/api/quickbooks/credit-notes/export.csv`, {
    params,
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'credit-notes.csv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export default {
  getCreditNotes,
  getCreditNotesSummary,
  getCreditNoteDetail,
  downloadCreditNotesCsv,
};
